import React from "react";

const Alert = ({
  svg = "",
  iconFlag = "gray-600",
  textFlag = "gray-600",
  text = "This email or password already exist",
  bgColor = "red-200",
}) => {
  return (
    <div
      className={`w-full p-2 bg-${bgColor} flex items-center space-x-3 rounded-md`}
    >
      <div className={`h-10 w-10 text-${iconFlag} self-start`}>{svg}</div>
      <h1 className={`text-${textFlag} font-medium text-sm leading-6 `}>
        {text}
      </h1>
    </div>
  );
};

export default Alert;
